module.exports = __webpack_public_path__ + "static/media/promo-management-2.e68a9bfa.png";